import Link from "next/link";
import React from "react";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import {
  TextBodyVariantsProps,
} from "apps/website/components/base/Text/TextBody/styles";

import { generateSignupHelpMailto, UserContactDetails } from "../misc/email";

const textBody = (chunks: React.ReactNode, size: TextBodyVariantsProps["size"] = 2) => <TextBody tag="span" size={size}>{ chunks }</TextBody>;

export const boldTextBody = (chunks: React.ReactNode): React.ReactNode => (
  <strong>
    { chunks }
  </strong>
);

export const createLinkText = (
  chunks: React.ReactNode,
  href: string,
  size?: TextBodyVariantsProps["size"],
  className?: string,
): React.ReactNode => (
  <Link className={`underline inline ${className || ""}`} href={href}>
    <TextBody className="inline" size={size} weight="bold">
      { chunks }
    </TextBody>
  </Link>
);

export const createEmailContactLink = (
  chunks: React.ReactNode,
  email = "meow@katkin.com",
  size: TextBodyVariantsProps["size"] = 1,
  weight: TextBodyVariantsProps["weight"] = "bold",
): React.ReactNode => (
  <Link className="underline inline" href={`mailto:${email}`}>
    <TextBody tag="span" className="inline" size={size} weight={weight}>
      { chunks }
    </TextBody>
  </Link>
);

export const createPrepopulatedEmailLink = (
  chunks: React.ReactNode,
  userDetails?: UserContactDetails,
  size: TextBodyVariantsProps["size"] = 1,
  weight: TextBodyVariantsProps["weight"] = "bold",
): React.ReactNode => {
  const mailtoLink = generateSignupHelpMailto(userDetails || {});

  return (
    <Link className="underline inline" href={mailtoLink}>
      <TextBody tag="span" className="inline" size={size} weight={weight}>
        { chunks }
      </TextBody>
    </Link>
  );
};

export const createLoginLink = (
  chunks: React.ReactNode,
  size: TextBodyVariantsProps["size"] = 2,
  weight: TextBodyVariantsProps["weight"] = "bold",
): React.ReactNode => (
  <Link className="underline inline" href="/login">
    <TextBody tag="span" size={size} weight={weight}>
      { chunks }
    </TextBody>
  </Link>
);

export const richCommon = {
  br: () => <br />,
  email: createEmailContactLink,
  strong: boldTextBody,
  link: createLinkText,
  textBody,
  span: (chunks: React.ReactNode) => <span>{ chunks }</span>,
};

export const renderRichTranslations = <T extends Record<string, unknown>>(
  t: (key: string, values?: Record<string, string | number>) => string,
  key: string,
  extra?: T,
) => {
  const richComponents = { ...richCommon, ...extra };
  return (t as any).rich(key, richComponents); // eslint-disable-line @typescript-eslint/no-explicit-any
};
